import { request } from './repository';

const url = 'questionnaire-answers/';

const questionnaireAnswersRepository = {
    updateAnswer(procedure_id, data){
        return request.put(url + procedure_id, data)
    }
}

export default questionnaireAnswersRepository